import { cn } from '@/utils/classname';
import { inverted, Tooltip, TooltipContent, TooltipTrigger } from '@skand/ui';
import { forwardRef, ReactNode } from 'react';

export const AnnotationPopupIconButton = forwardRef<
  HTMLDivElement,
  {
    icon: ReactNode;
    tooltip: ReactNode;
    onClick?: () => void;
    isActive?: boolean;
    isDisabled?: boolean;
    analyticsEventObject?: string;
  }
>(({ icon, tooltip, onClick, isActive, isDisabled, analyticsEventObject }, ref) => {
  return (
    <Tooltip disableHoverableContent={isDisabled}>
      <TooltipTrigger asChild>
        <div
          className={cn(
            'w-6 h-6 items-center justify-center flex',
            isActive && 'color-primary-400',
            isDisabled
              ? 'color-neutral-300'
              : 'hover:color-neutral-600 color-neutral-500 cursor-pointer',
          )}
          data-analytics-event-object={analyticsEventObject}
          onClick={onClick}
          ref={ref}
        >
          {icon}
        </div>
      </TooltipTrigger>
      <TooltipContent align="center" side="bottom" sideOffset={8}>
        <div className={inverted}>{tooltip}</div>
      </TooltipContent>
    </Tooltip>
  );
});

AnnotationPopupIconButton.displayName = 'AnnotationPopupIconButton';
